import { render } from "./GenericStatisticsBox.vue?vue&type=template&id=eb8f36c0&scoped=true"
import script from "./GenericStatisticsBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./GenericStatisticsBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./GenericStatisticsBox.vue?vue&type=style&index=0&id=eb8f36c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8f36c0"]])

export default __exports__